import { HPEvent, PastEvent } from '../types'

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/ccd03528-e77b-4c5a-b4f6-fba08b4b81db.jpg',
  roundtable: 'https://cdn.magicpatterns.com/patterns/generated-images/9b1005d6-b9b7-4623-83c9-fffa9228e199.jpg',
  pitchDay: 'https://cdn.magicpatterns.com/patterns/generated-images/4a05ccf5-d85d-4850-b367-333a2c99f97e.jpg',
  reception: 'https://cdn.magicpatterns.com/patterns/generated-images/fb0138fb-8632-48b5-a8da-14be6eac5d21.jpg',
  panel: 'https://cdn.magicpatterns.com/patterns/generated-images/ed39bedc-9354-44ab-b3bc-23e51b2ee2f8.jpg',
  workshop: 'https://cdn.magicpatterns.com/patterns/generated-images/09151606-f41b-4942-9492-4a60f3758577.jpg',
  signing: 'https://cdn.magicpatterns.com/patterns/generated-images/699db6b8-cae8-4110-a7c8-f65af714f399.jpg',
  fieldVisit: 'https://cdn.magicpatterns.com/patterns/generated-images/0b744084-2179-4b7a-b89d-91ea4ccbe2b7.jpg',
}

export const PROFILE_OPTIONS = [
  'Changemaker or impact venture',
  'Impact investor or financial sector',
  'Corporate',
  'Government, multilateral or donor',
  'Other',
]

export const events: HPEvent[] = [
  {
    id: 'giin-amsterdam-2026',
    slug: 'giin-amsterdam-2026',
    code: 'GIIN',
    title: 'Human Planet at the GIIN Impact Forum',
    strapline: 'Investor ready spaces in Amsterdam for high impact NGO pitches and networking',
    format: 'Summit',
    date: '2026-10-07T07:00:00.000Z',
    timeRange: '09:00 to 18:00 CEST',
    city: 'Amsterdam',
    venue: 'Kromhouthal, Gedempt Hamerkanaal 231',
    capacity: 200,
    audience: 'Impact investors, foundations, NGOs and development finance institutions',
    description:
      'A curated selection of relaxed, investor ready spaces in Amsterdam designed to host 150 to 200 attendees for high impact NGO pitches and networking. Human Planet convenes the programme alongside the GIIN Impact Forum, pairing prepared organisations with the capital providers most likely to move.',
    themes: ['Impact investing', 'NGO pitches', 'Blended finance', 'Networking'],
    agenda: [
      {
        time: '09:00',
        title: 'Doors and coffee',
        description: 'Tickets scanned at the desk. Badges and pitch schedules collected on arrival.',
      },
      {
        time: '09:45',
        title: 'Opening: what makes an NGO investable',
        speaker: 'Human Planet Partners',
        description: 'A short framing of the structures capital providers in the room can actually deploy into.',
      },
      {
        time: '10:15',
        title: 'Pitch block one',
        description: 'Six organisations present investment ready cases with ten minutes of questions each.',
      },
      { time: '12:00', title: 'Standing lunch and matched introductions' },
      {
        time: '13:30',
        title: 'Pitch block two',
        description: 'Six further organisations present, with capital providers seated by thematic interest.',
      },
      {
        time: '15:15',
        title: 'Working salons',
        description: 'Three parallel rooms on guarantees, outcome funding and carbon linked revenue.',
      },
      { time: '16:45', title: 'Closing reflections and drinks reception' },
    ],
    speakers: [
      { name: 'Dr Lina Okonjo', role: 'Partner, Blended Finance', organisation: 'Human Planet' },
      { name: 'Sofia Marchetti', role: 'Managing Director', organisation: 'Nature Capital Alliance' },
      { name: 'Priya Raghunathan', role: 'Founder and CEO', organisation: 'TerraFibre' },
      { name: 'Yasmin Haddad', role: 'Director, Adaptation Finance', organisation: 'Regional Development Bank' },
    ],
    partners: ['GIIN Impact Forum', 'Kromhouthal'],
    image: IMAGES.hero,
    registrationOpen: true,
  },
  {
    id: 'avpn-2026',
    slug: 'avpn-2026',
    code: 'AVPN',
    title: 'Human Planet at the AVPN Global Conference',
    strapline: 'Channelling financial, human and intellectual capital towards impact across Asia',
    format: 'Summit',
    date: '2026-11-18T02:00:00.000Z',
    timeRange: '10:00 to 17:00 SGT',
    city: 'Singapore',
    venue: 'Sands Expo and Convention Centre',
    capacity: 150,
    audience: 'Social investors, family offices, foundations and regional intermediaries',
    description:
      'AVPN is the largest network of social investors in Asia, comprising over 600 diverse members across 33 markets. Its mission is to increase the flow and effectiveness of financial, human, and intellectual capital in Asia by enabling members to channel resources towards impact. As an ecosystem builder, AVPN connects, learns, acts, and leads across key pillars and improves the effectiveness of capital deployed, bringing to bear local field needs, regional expertise, and policy insights. Human Planet hosts a working day inside the conference on structuring for Asian markets.',
    themes: ['Social investment', 'Asia markets', 'Capital effectiveness', 'Policy insight'],
    agenda: [
      { time: '10:00', title: 'Welcome and framing with AVPN' },
      {
        time: '10:30',
        title: 'Panel: what regional capital is ready to fund',
        speaker: 'Family offices and foundations',
      },
      {
        time: '11:30',
        title: 'Working session: local field needs to bankable structure',
        description: 'Small groups translate context specific needs into instruments capital can enter.',
      },
      { time: '13:00', title: 'Lunch and member introductions' },
      { time: '14:15', title: 'Case clinic: three live vehicles under construction' },
      { time: '16:00', title: 'Policy insight briefing and close' },
    ],
    speakers: [
      { name: 'Wei Ling Tan', role: 'Head of Capital Mobilisation', organisation: 'Regional social investor' },
      { name: 'Dr Martin Reiss', role: 'Partner, Governance', organisation: 'Human Planet' },
      { name: 'Arjun Nair', role: 'Director', organisation: 'Family office network, India' },
    ],
    partners: ['AVPN'],
    image: IMAGES.panel,
    registrationOpen: true,
  },
  {
    id: 'wef-davos-2027',
    slug: 'wef-davos-2027',
    code: 'WEFD',
    title: 'Human Planet Side Event at the World Economic Forum',
    strapline: 'A closed evening session in Davos on moving from pledges to bankable structures',
    format: 'Roundtable',
    date: '2027-01-20T17:00:00.000Z',
    timeRange: '18:00 to 21:00 CET',
    city: 'Davos',
    venue: 'Private venue on the Promenade',
    capacity: 60,
    audience: 'Sovereign entities, institutional investors, corporates and multilateral leadership',
    description:
      'A side event held during the Annual Meeting, away from the main stages. Sixty seats, Chatham House rule, and one question on the table: which structures are ready to absorb capital this year, and who carries the first loss. Dinner is served during the working session.',
    themes: ['Sovereign finance', 'First loss capital', 'Transition planning'],
    agenda: [
      { time: '18:00', title: 'Arrival and drinks' },
      { time: '18:40', title: 'Opening provocation from the Partners' },
      { time: '19:00', title: 'Table work over dinner', description: 'Six tables, one structuring question each.' },
      { time: '20:20', title: 'Report back and commitments' },
    ],
    speakers: [
      { name: 'Human Planet Partners', role: 'Founding Partners', organisation: 'Human Planet' },
      { name: 'Amina Al Rashid', role: 'Head of Sustainable Investments', organisation: 'Gulf Sovereign Fund' },
    ],
    partners: [],
    image: IMAGES.roundtable,
    registrationOpen: true,
  },
]

export const pastEvents: PastEvent[] = [
  {
    id: 'past-idrc-2026',
    title: 'Evidence for Impact with IDRC',
    format: 'Roundtable',
    date: '2026-05-12T00:00:00.000Z',
    city: 'Ottawa',
    attendees: 74,
    summary:
      'The International Development Research Centre (IDRC) is a Canadian Crown corporation that funds research in developing countries to create lasting change on a large scale. IDRC supports local organisations in the Global South to generate the evidence that is relevant in their context, providing financial resources, advice, and training to researchers in developing countries to help them find solutions to local problems, and encouraging knowledge sharing with policy makers, researchers, and communities. Human Planet convened funders and researchers to turn that evidence base into investable programme design.',
    outcomes: [
      '74 delegates across 21 institutions',
      '9 research programmes mapped to funding routes',
      'Shared evidence to finance framework published',
    ],
    images: [IMAGES.roundtable, IMAGES.fieldVisit],
  },
  {
    id: 'past-dragons-2025',
    title: 'Dragons Day 2025',
    format: 'Pitch Day',
    date: '2025-10-16T00:00:00.000Z',
    city: 'Berlin',
    attendees: 84,
    summary:
      'The first accelerator cohort presented to a room of family offices, foundations and catalytic funders. Four of five ventures moved into diligence within eight weeks.',
    outcomes: ['EUR 11.4m in term sheets issued', 'Four of five ventures into diligence', '38 investor introductions'],
    images: [IMAGES.pitchDay, IMAGES.panel],
  },
  {
    id: 'past-modelling-2025',
    title: 'Investment Readiness Intensive',
    format: 'Workshop',
    date: '2025-06-11T00:00:00.000Z',
    city: 'Brussels',
    attendees: 32,
    summary:
      'Two days of financial modelling, market research and pitch preparation with organisation led initiatives preparing to access blended and catalytic capital.',
    outcomes: ['32 participants from 18 organisations', '11 investor ready models built', '6 accelerator applications'],
    images: [IMAGES.workshop, IMAGES.signing],
  },
]

export function getEventBySlug(slug: string): HPEvent | undefined {
  return events.find((event) => event.slug === slug)
}

export function getEventById(id: string): HPEvent | undefined {
  return events.find((event) => event.id === id)
}

export const galleryImages = [
  { src: IMAGES.roundtable, caption: 'Evidence for Impact with IDRC, Ottawa 2026' },
  { src: IMAGES.fieldVisit, caption: 'Research field visit, Kenya 2026' },
  { src: IMAGES.pitchDay, caption: 'Dragons Day, Berlin 2025' },
  { src: IMAGES.panel, caption: 'Adaptation finance panel, New York 2025' },
  { src: IMAGES.hero, caption: 'Natural capital mainstage, New York 2025' },
  { src: IMAGES.workshop, caption: 'Investment Readiness Intensive, Brussels 2025' },
  { src: IMAGES.signing, caption: 'Sovereign carbon signing, Nairobi 2025' },
  { src: IMAGES.reception, caption: 'Partner reception, Amsterdam 2025' },
]
